<template>
  <div class="login_form_wrap">
    <Form @submit="onSubmit" class="form_list" validate-trigger="onSubmit">
      <Field v-model="formValue[item.key]" :placeholder="$t(item.label)" v-for="(item, index) in formList"
        :key="`form_item_${index}`" :rules="item.rules || []" :maxlength="item.length || 99" :type="item.type || 'text'"
        :readonly="item.readonly || false" :disabled="item.disabled || false">
        <template #left-icon>
          <template v-if="item.needTrue">
            <Area v-model="areaCode" @confirm="areaConfirm" />
            <!-- <div class="userInfo_text" @click="show = true">
              +{{ areaCode }}
            </div> -->
          </template>
          <template v-else>
            <i class="iconfont" :class="item.icon" v-if="item.icon"></i>
            <Img height="18" style="margin-left:20px" :src="item.img" fit="scale-down" v-if="item.img" />
          </template>
        </template>
        <template #right-icon>
          <slot :name="`surfix_${item.key}`"></slot>
          <template v-if="item.isPassword">
            <i class="iconfont" :class="item.type === 'password'
              ? 'icon-yanjing_xianshi_o'
              : 'icon-yanjing_yincang_o'
              " @click="showPassword(item, index)"></i>
          </template>
        </template>
      </Field>
      <slot name="read">
        <div class="read_wrap" v-if="isRead">
          <Checkbox v-model="read" shape="square" checked-color="var(--yellow)">
            {{ $t(readText) }}
          </Checkbox>
          <div class="forgot" @click="forgetPassword">{{ $t("忘记密码") }}</div>
        </div>
      </slot>
      <slot name="confirm">
        <div class="btns">
          <Btn block native-type="submit" class="confirm">
            {{ $t(confirmText) }}
          </Btn>
        </div>
      </slot>
    </Form>
    <!-- <slot name="cancel">
      <div class="btn_wrap">
        <Btn round block plain class="cancel" @click="handleClose">
          {{ $t(cancelText) }}
        </Btn>
      </div>
    </slot> -->
    <van-popup v-model="show" round position="bottom">
      <van-picker show-toolbar :confirm-button-text="$t('My.Button.Two')" :default-index="defaultIndex"
        :cancel-button-text="$t('My.Button.One')" :columns="actions" @cancel="show = false" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Image as Img,
  Field,
  Form,
  Button as Btn,
  Checkbox,
  Toast,
  Picker,
  Popup
} from "vant";
import Area from "@/components/area"
export default {
  props: {
    readText: {
      type: String,
    },
    isRead: Boolean,
    confirmText: {
      type: String,
      default: "Login.Forgot.confirm",
    },
    cancelText: {
      type: String,
    },
    needRead: {
      type: Boolean,
      default: false,
    },
    formList: {
      type: Array,
      default: () => [],
    },
    getRemember: {
      type: Boolean,
      default: false,
    },
    tabNum: {
      type: Number,
      default: -1
    }
  },
  components: {
    Icon,
    Img,
    Field,
    Form,
    Btn,
    Checkbox,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    Area
  },
  data() {
    return {
      formValue: {},
      read: true,
      show: false,
      actions: [63, 33, 91, 1, 84, 971, 66, 62, 966, 974, 965, 852],
      areaCode: this.verConfig.areaCode,
      defaultIndex: 0,
      areaItem: {}
    };
  },
  created() {
    this.initValue();
    const { id: fromid } = this.$route.query;
    if (fromid) {
      this.$set(this.formValue, "fromid", fromid);
    }
    if (this.getRemember) {
      let storePwd = localStorage.getItem("the-pwd-obj");
      if (storePwd) {
        storePwd = JSON.parse(storePwd);
        this.$set(this.formValue, "userphone", storePwd.userphone);
        this.$set(this.formValue, "userpass", storePwd.userpass);
      }
    }
    this.defaultIndex = this.actions.findIndex(item => item == this.verConfig.areaCode);
  },
  watch: {
    tabNum: {
      handler(newVal, oldVal) {
        if (this.getRemember) {
          let storePwd = localStorage.getItem("the-pwd-obj");
          let storeEmail = localStorage.getItem("the-email-obj");
          if (storePwd && newVal == 0) {
            storePwd = JSON.parse(storePwd);
            this.$set(this.formValue, "userphone", storePwd.userphone);
            this.$set(this.formValue, "userpass", storePwd.userpass);
          } else if (storeEmail && newVal == 1) {
            storePwd = JSON.parse(storeEmail);
            this.$set(this.formValue, "email", storePwd.email);
            this.$set(this.formValue, "userpass", storePwd.userpass);
          } else {
            this.$set(this.formValue, "userphone", '');
            this.$set(this.formValue, "email", '');
            this.$set(this.formValue, "userpass", '');
          }
        }
      },
      deep: true
    },
    formList: {
      handler(newVal, oldVal) {
        this.initValue();
      },
      deep: true
    },
    formValue: {
      handler(newVal, oldVal) {
        this.$emit('defaultValue', { ...newVal })
      },
      deep: true
    }
  },
  methods: {
    areaConfirm(item) {
      this.areaItem = item;
      item && this.$emit('defaultValue', { ...this.formValue, country_code: this.areaItem.code })
    },
    onConfirm(code, index) {
      this.areaCode = code;
      this.show = false;
      this.defaultIndex = index;
    },
    initValue() {
      for (let index = 0; index < this.formList.length; index++) {
        const item = this.formList[index];
        if (this.formValue[item.key]) { } else {
          this.$set(this.formValue, item.key, item.defaultValue || "");
        }
      }
    },
    onSubmit(values) {
      if (this.needRead && !this.read) return Toast(this.$t("hint.read"));
      if (this.tabNum == 0) {
        let country_code = this.areaItem.code && this.areaItem.code.split('+')[1]
        const { email, ...phoneForm } = this.formValue
        this.$emit("submit", { ...phoneForm, country_code: country_code }, this.read);
      } else if(this.tabNum == 1) {
        const { userphone, ...emailForm } = this.formValue
        this.$emit("submit", { ...emailForm }, this.read);
      }else{
         this.$emit("submit", { ...this.formValue }, this.read);
      }
    },
    showPassword(item, index) {
      let type = "password";
      if (item.type === "password") {
        type = "text";
      }
      this.formList[index].type = type;
    },
    handleClose() {
      for (const key in this.formValue) {
        if (Object.hasOwnProperty.call(this.formValue, key)) {
          this.formValue[key] = "";
        }
      }
      this.$emit("cancel");
    },
    forgetPassword() {
      this.$apis.toService()
    }
  },
};
</script>

<style lang="less" scoped>
.login_form_wrap {
  .form_list {
    margin: calc(20rem / 16) calc(16rem / 16) 0;
    overflow: hidden;

    .iconfont {
      font-size: calc(20rem / 16);
      margin-right: calc(5rem / 16);
      // color: #00bbfe;
      color: var(--textColor);
    }

    /deep/ .van-field__control:disabled {
      color: var(--gray2);
      -webkit-text-fill-color: var(--gray2);
    }

    /deep/ .van-cell {
      background-color: transparent;
      margin-top: calc(19rem / 16);
      line-height: inherit;
      align-items: center;
      padding: 0;
      background-color: #fff;
      border-radius: 4px;

      .userInfo_text {
        padding-left: 20px;
        color: var(--textColor);
      }

      .van-field__left-icon {
        margin-right: 0;
      }

      .van-field__body {
        padding: 0 20px;
        height: 43px;
        border-radius: 99px;
      }

      .van-field__error-message {
        padding-left: 10px;
        margin-top: 5px;
      }

      &:nth-child(1) {
        margin-top: 0;
      }

      &::after {
        border: none;
      }

      input::placeholder {
        color: var(--gray1);
        // color: #eee;
      }

      input {
        // color: var(--textColor);
        color: var(--textColor);
      }
    }

    .read_wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: calc(20rem / 16);

      /deep/ .van-checkbox {
        .van-icon {
          border-radius: 2px;
        }

        .van-checkbox__label {
          // color: #8ba6ce;
          color: var(--theme);
          font-size: calc(13rem / 16);
          letter-spacing: 1px;
        }
      }

      .forgot {
        color: var(--theme);
        font-size: calc(12rem / 16);
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .btns {
      margin-top: calc(42rem / 16);

      .confirm {
        width: 100%;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        text-shadow: 0 1px 1px #5f4a21;
        margin: 10px 0 0;
        height: 44px;
        background: url('../../../assets/login/btn_bg.png') no-repeat 50% / contain !important;
        transition: all .3s ease;
        padding: 4px 10px;
        border-color: transparent !important;
      }
    }
  }

  .btn_wrap {
    margin: calc(28rem / 16) calc(16rem / 16);
  }
}
</style>
